import { TipoEntidade } from "./entidade";

export class Dominios {
  id?: number;
  nome?: string;
  name?:string;
  descricao?: string;

  constructor(nome?: string, descricao?: string) {
    this.nome = nome;
    this.descricao = descricao;
  }
}

export class DominiosFilter {

  nome?: string;

  descricao?: string;

  constructor(nome?: string, descricao?: string) {
    this.nome = nome;
    this.descricao = descricao;
  }
}

export class Dominio {
  id!: number;
  nome!: string;
  dataCadastro!: Date;
  dataInativo!: Date;
  tipoEntidade!: tipoEntidade;
  telasPermitidas: any[] = [];
  cargoSubordinado!: any;
  tipoCargo!: any;
  tipoGrupo : any;
  codigoPai!: any;
  nivelHierarquico!:number;
  cargoReferencia!: cargoReferencia;
  sigiloso!: boolean;
  cargosAssociados!: any[];
  nomeSubTipoEntidade!: string;
  nomeTipoEntidade!: string;
  especificacoesStr!: string;
  nomeSubTipoAssociado!: string;
  existeCargosAssociados!: boolean;
  especificacoes!: any[];
  subTipos!: SubTipoCargo[]; 

}

export interface SubTipoCargo {
  idSubTipo: number;
  nomeSubTipo: string;
  idTipoOrgao?: number | null;
  nomeTipoOrgao?: string | null;
  possuiCargos: boolean;
}

export interface tipoEntidade{
  id: number;
  nomeTipoEntidade: string;
  dataCadastro: Date;
  dataInativo: Date;
  idEntidadeReponsavel: number;
}

export interface cargoReferencia{

  id: number;
  nomeCargoReferencia?: string;
  nivelHierarquico: number;
  codigo: number;
  cargoSubordinado: number;
  dataCadastro: Date;
  dataInativo: Date;
  suplente: boolean;
  efetivo: boolean;
}

export class DominioFilter {
  nome?: string;
  tipoEntidade?: number;
  subTipo?: number;
  idEspecificacao?: number;

  constructor(nome?: string, tipoEntidade?: number, subTipo?: number, idEspecificacao?: number) {
    this.nome = nome;
    this.tipoEntidade = tipoEntidade;
    this.subTipo = subTipo;
    this.idEspecificacao = idEspecificacao;
  }
}

export class DominioEntidade extends Dominio {

  flagEmpresaRespCadastro!: boolean;
}

export class DominioCombo {

  codigo: any;

  descricao: any;

  id: any;

  nome: any;

  constructor(codigo: any, descricao?: string) {
    this.codigo = codigo;
    this.descricao = descricao;
  }
}


export enum NomeTelasEnum {
  ENTIDADE = 'Entidade',
  VINCULO = 'Vinculo',
  PESSOA = 'Pessoa',
}
